import { render, staticRenderFns } from "./invoiceClaim.vue?vue&type=template&id=54ea4bea&scoped=true&"
import script from "./invoiceClaim.vue?vue&type=script&lang=js&"
export * from "./invoiceClaim.vue?vue&type=script&lang=js&"
import style0 from "./invoiceClaim.vue?vue&type=style&index=0&id=54ea4bea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ea4bea",
  null
  
)

export default component.exports